export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'entertainment',
    name: '娱乐搞笑',
    description: '汇集最新热门搞笑视频、娱乐综艺片段、趣味短片，让您开怀大笑，放松心情。',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'tutorial',
    name: '教程学习',
    description: '专业技能教学、软件使用教程、编程知识分享，助您轻松掌握各类实用技能。',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'tech',
    name: '科技数码',
    description: '最新科技资讯、数码产品评测、前沿技术解读，带您了解科技世界的最新动态。',
    icon: 'ri-smartphone-line',
  },
  {
    slug: 'lifestyle',
    name: '生活记录',
    description: '旅行Vlog、美食探店、日常记录、家居生活，感受真实多元的生活方式。',
    icon: 'ri-heart-line',
  },
  {
    slug: 'music',
    name: '音乐舞蹈',
    description: '原创音乐作品、舞蹈表演、乐器演奏、音乐教学，享受视听盛宴。',
    icon: 'ri-music-line',
  },
  {
    slug: 'sports',
    name: '体育竞技',
    description: '精彩赛事集锦、运动技巧教学、健身训练指导，点燃您的运动激情。',
    icon: 'ri-basketball-line',
  },
  {
    slug: 'gaming',
    name: '游戏电竞',
    description: '热门游戏实况、电竞赛事直播、游戏攻略解说，与千万玩家共享游戏乐趣。',
    icon: 'ri-gamepad-line',
  },
  {
    slug: 'news',
    name: '新闻资讯',
    description: '时事热点解读、深度新闻报道、社会观察评论，第一时间掌握重要资讯。',
    icon: 'ri-newspaper-line',
  },
];